import {
  Drawer as DrawerMantine,
  Flex,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

interface IProps {
  opened: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title: string;
  childrenFooter?: React.ReactNode;
  heightBody: string;
}

const Drawer = ({
  opened,
  onClose,
  title,
  children,
  childrenFooter,
  heightBody,
}: IProps) => {
  const theme = useMantineTheme();
  const isLargerThan991 = useMediaQuery("(min-width: 991px)");
  return (
    <DrawerMantine.Root
      opened={opened}
      onClose={onClose}
      position="right"
      size={isLargerThan991 ? 659 : "100%"}
    >
      <DrawerMantine.Overlay />
      <DrawerMantine.Content
        style={{ background: "#theme.colors.other[0]", position: "relative" }}
      >
        <DrawerMantine.Header
          p={{ base: "24px", 991: "48px" }}
          style={{
            gap: "24px",
            alignItems: "center",
            justifyContent: "start",
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10)",
            background: "white",
          }}
        >
          <DrawerMantine.CloseButton
            size={isLargerThan991 ? "36px" : "24px"}
            style={{ margin: "0" }}
          />
          <Text fs={"24px"} fw={600} lh="24px" color={theme.colors.basic[5]}>
            {title}
          </Text>
        </DrawerMantine.Header>
        <DrawerMantine.Body
          style={{
            background: "#theme.colors.other[0]",
            minHeight: heightBody,
          }}
          p="unset"
        >
          {children}
        </DrawerMantine.Body>
        {childrenFooter ? (
          <Flex
            p={{ base: 24, 991: 48 }}
            pos={"absolute"}
            bottom={0}
            w={"100%"}
            align={"center"}
            justify={"center"}
            gap="24px"
            style={{
              height: "fit-content",
              background: "transparent",
            }}
          >
            {childrenFooter}
          </Flex>
        ) : null}
      </DrawerMantine.Content>
    </DrawerMantine.Root>
  );
};

export default Drawer;
